import { CORE_COLOR_MAP } from 'Angular/constants/core.constants';
export const GENERAL_CHART_DEFAULT_CONFIG_OPTIONS = {
    // map to override tooltip hover labels
    // should be a mapping of security id's to their desired label
    tooltipOverride: {},
    tooltipStyle: 'box',
};
export const HIGHCHARTS_GENERAL_DEFAULT_OPTIONS = {
    chart: {
        plotBackgroundColor: 'transparent',
        backgroundColor: 'transparent',
        plotBorderColor: '#e5e5e5',
        plotBorderWidth: 1,
        spacing: [1, 1, 1, 1],
        style: {
            fontFamily: 'Roboto Condensed',
        },
        type: 'column',
        resetZoomButton: {
            theme: {
                style: {
                    display: 'none',
                },
            },
        },
    },
    colors: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((n) => CORE_COLOR_MAP[n].code),
    credits: false,
    exporting: { enabled: false },
    legend: { enabled: false },
    navigator: { enabled: false },
    plotOptions: {
        column: {
            borderRadius: 0,
            borderWidth: 0,
            groupPadding: 0.1,
            pointPadding: 0,
        },
        series: {
            marker: { enabled: false },
            states: {
                hover: {
                    enabled: false,
                },
                inactive: {
                    opacity: 1,
                },
            },
        },
    },
    series: [
        {
            data: [],
            tooltip: {},
        },
    ],
    title: { text: '' },
    tooltip: {
        style: {
            color: 'auto',
        },
        backgroundColor: null,
        shadow: false,
        borderColor: null,
        borderRadius: 0,
        borderWidth: 0,
        followPointer: true,
        hideDelay: 0,
        padding: 5,
        useHTML: true,
        shared: true,
        split: false,
        valueDecimals: 2,
        outside: true,
    },
    xAxis: {
        alternateGridColor: 'transparent',
        categories: [],
        className: 'chart-axis-x chart-axis-x-item',
        crosshair: {
            color: '#808080',
            dashStyle: 'Solid',
            snap: false,
            width: 1,
        },
        gridLineWidth: 1,
        labels: {
            align: 'center',
            autoRotation: [20],
            style: {
                fontSize: 12,
                color: '#666',
            },
            y: 18,
        },
        lineWidth: 0,
        startOnTick: false,
        endOnTick: false,
        tickLength: 0,
        tickmarkPlacement: 'on',
    },
    yAxis: {
        className: 'chart-axis-y chart-axis-y-item',
        labels: {
            align: 'right',
            style: {
                fontSize: 12,
                color: '#666',
            },
            x: -6,
        },
        lineWidth: 0,
        opposite: false,
        showFirstLabel: false,
        showLastLabel: false,
        title: { text: '' },
    },
};
